import {
  TextField as MuiTextField,
  FormControl,
  type InputBaseComponentProps,
} from "@mui/material";
import {
  type ISizingWrapperProps,
  SizingWrapper,
  type SizingWrapperStyle,
} from "@/components/Wrapper/SizingWrapper";

interface IProps extends ISizingWrapperProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onKeyUp?: (value: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (value: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  autoFocus?: boolean;
  type?: React.InputHTMLAttributes<unknown>["type"];
  size?: SizingWrapperStyle;
  disabled?: boolean;
  inputProps?: InputBaseComponentProps;
  error?: boolean;
  helperText?: string;
}

const TextField: React.FC<IProps> = (props) => {
  const {
    label,
    value,
    onChange,
    onKeyUp,
    onBlur,
    required,
    autoFocus,
    type,
    id,
    size,
    disabled,
    inputProps,
    error,
    helperText,
  } = props;

  return (
    <SizingWrapper size={size}>
      <FormControl fullWidth>
        <MuiTextField
          id={id}
          label={label}
          value={value}
          error={error}
          helperText={helperText}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value);
          }}
          onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (onKeyUp) {
              onKeyUp(event);
            }
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            if (onBlur) {
              onBlur(event);
            }
          }}
          required={required}
          autoFocus={autoFocus}
          type={type}
          disabled={disabled}
          inputProps={inputProps}
        />
      </FormControl>
    </SizingWrapper>
  );
};
export { TextField };
